module.exports = __webpack_public_path__ + "img/hezuohuoban.4a4692d0.png";